import React, { useEffect, useState } from "react";
import { ContactInterface } from "../../../../service/Business/Interfaces/ContactInterface";
import TypeContact from "../../../../utils/Business/TypeContact";
import FCSelect, { FCSelectOption } from "../../../FCObjets/Form/FCSelect";

type TableContactCustomerProps = {
    dataContact: ContactInterface[];
    handlerEvent: (
        listContactAdd: ContactInterface[],
        listContactDel: ContactInterface[],
        listContactModify: ContactInterface[],
    ) => void;
    /** Callback transmis au parent pour déclencher l'ajout depuis le header de section */
    onAddContact?: (fn: () => void) => void;
};

const TableContactCustomer: React.FunctionComponent<TableContactCustomerProps> = (props) => {
    const [listContactTable, setListContactTable] = useState<ContactInterface[]>(props.dataContact);
    const [listContactAdd, setListContactAdd] = useState<ContactInterface[]>([]);
    const [listContactDel, setListContactDel] = useState<ContactInterface[]>([]);
    const [listContactModify, setListContactModify] = useState<ContactInterface[]>([]);
    const [currentName, setCurrentName] = useState<string>("");
    const [currentPhone, setCurrentPhone] = useState<string>("");
    const [currentAddress, setCurrentAddress] = useState<string>("");
    const [currentType, setCurrentType] = useState<number>(0);

    const [editingRowId, setEditingRowId] = useState<number | null>(null);
    const [cptAdd, setCptAdd] = useState<number>(-1);

    const optionsDrop: FCSelectOption[] = TypeContact.ListType.map((t) => ({
        value: t,
        label: TypeContact.toString(t),
    }));

    // Expose la fonction addContact au parent via callback
    useEffect(() => {
        if (props.onAddContact) {
            props.onAddContact(addContact);
        }
    }, [cptAdd]);

    useEffect(() => {
        let listTmp: ContactInterface[] = [...props.dataContact, ...listContactAdd];
        for (const del of listContactDel) {
            listTmp = listTmp.filter((row) => row.id !== del.id);
        }
        for (const mod of listContactModify) {
            listTmp = listTmp.map((row) =>
                row.id === mod.id
                    ? { ...row, name: mod.name, phone: mod.phone, address: mod.address, type: mod.type }
                    : row,
            );
        }
        setListContactTable(listTmp);
        props.handlerEvent(listContactAdd, listContactDel, listContactModify);
    }, [listContactAdd, listContactDel, listContactModify]);

    const addContact = () => {
        const id = cptAdd;
        const newContact: ContactInterface = { address: "", id, name: "", phone: "", type: 0 };
        setListContactAdd((prev) => [...prev, newContact]);
        setCptAdd((prev) => prev - 1);
        setEditingRowId(id);
        setCurrentName("");
        setCurrentPhone("");
        setCurrentAddress("");
        setCurrentType(0);
    };

    const delContact = (contact: ContactInterface) => {
        if (contact.id <= -1) {
            setListContactAdd((prev) => prev.filter((row) => row.id !== contact.id));
        } else {
            setListContactDel((prev) => [...prev, contact]);
        }
        if (editingRowId === contact.id) setEditingRowId(null);
    };

    const handleSaveRow = (id: number, newName: string, newPhone: string, newAddress: string, type: number) => {
        const existOnAdd = listContactAdd.find((c) => c.id === id);
        const existOnModify = listContactModify.find((c) => c.id === id);

        if (existOnAdd) {
            setListContactAdd((prev) =>
                prev.map((row) =>
                    row.id === id ? { ...row, name: newName, phone: newPhone, address: newAddress, type } : row,
                ),
            );
        } else if (existOnModify) {
            setListContactModify((prev) =>
                prev.map((row) =>
                    row.id === id ? { ...row, name: newName, phone: newPhone, address: newAddress, type } : row,
                ),
            );
        } else {
            const existing = listContactTable.find((row) => row.id === id);
            if (existing) {
                const updated: ContactInterface = {
                    ...existing,
                    name: newName,
                    phone: newPhone,
                    address: newAddress,
                    type,
                };
                setListContactModify((mods) => [...mods, updated]);
            }
        }
    };

    return (
        <div className="ctcWrapper">
            <div className="ctcTableWrapper">
                <table className="ctcTable">
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Téléphone</th>
                            <th>Mail</th>
                            <th>Type</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listContactTable.length === 0 && (
                            <tr>
                                <td colSpan={5} className="ctcEmptyRow">
                                    Aucun contact — cliquez sur « Ajouter un contact »
                                </td>
                            </tr>
                        )}
                        {listContactTable.map((e: ContactInterface, index: React.Key) => (
                            <tr key={index} className={editingRowId === e.id ? "ctcRowEditing" : ""}>
                                <td>
                                    {editingRowId === e.id ? (
                                        <input
                                            className="ctcInput"
                                            type="text"
                                            value={currentName}
                                            placeholder="Nom complet"
                                            onChange={(ev) => {
                                                setCurrentName(ev.target.value);
                                                handleSaveRow(
                                                    e.id,
                                                    ev.target.value,
                                                    currentPhone,
                                                    currentAddress,
                                                    currentType,
                                                );
                                            }}
                                        />
                                    ) : (
                                        <span className="ctcCellName">{e.name || "—"}</span>
                                    )}
                                </td>
                                <td>
                                    {editingRowId === e.id ? (
                                        <input
                                            className="ctcInput"
                                            type="text"
                                            value={currentPhone}
                                            placeholder="+33 1 23 45 67 89"
                                            onChange={(ev) => {
                                                setCurrentPhone(ev.target.value);
                                                handleSaveRow(
                                                    e.id,
                                                    currentName,
                                                    ev.target.value,
                                                    currentAddress,
                                                    currentType,
                                                );
                                            }}
                                        />
                                    ) : (
                                        <span className="ctcCellPhone">{e.phone || "—"}</span>
                                    )}
                                </td>
                                <td>
                                    {editingRowId === e.id ? (
                                        <input
                                            className="ctcInput"
                                            type="text"
                                            value={currentAddress}
                                            placeholder="email@exemple.com"
                                            onChange={(ev) => {
                                                setCurrentAddress(ev.target.value);
                                                handleSaveRow(
                                                    e.id,
                                                    currentName,
                                                    currentPhone,
                                                    ev.target.value,
                                                    currentType,
                                                );
                                            }}
                                        />
                                    ) : (
                                        <span className="ctcCellMail">{e.address || "—"}</span>
                                    )}
                                </td>
                                <td>
                                    {editingRowId === e.id ? (
                                        <FCSelect
                                            options={optionsDrop}
                                            value={currentType}
                                            onChange={(v) => {
                                                setCurrentType(Number(v));
                                                handleSaveRow(
                                                    e.id,
                                                    currentName,
                                                    currentPhone,
                                                    currentAddress,
                                                    Number(v),
                                                );
                                            }}
                                        />
                                    ) : (
                                        <span className="ctcCellType">{TypeContact.toString(e.type)}</span>
                                    )}
                                </td>
                                <td>
                                    <div className="ctcActions">
                                        {editingRowId === e.id ? (
                                            <button
                                                type="button"
                                                className="ctcBtn ctcBtnConfirm"
                                                title="Valider"
                                                onClick={() => setEditingRowId(null)}
                                            >
                                                <span className="material-symbols-outlined">check</span>
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                className="ctcBtn ctcBtnEdit"
                                                title="Modifier"
                                                onClick={() => {
                                                    setEditingRowId(e.id);
                                                    setCurrentName(e.name);
                                                    setCurrentPhone(e.phone);
                                                    setCurrentAddress(e.address);
                                                    setCurrentType(e.type);
                                                }}
                                            >
                                                <span className="material-symbols-outlined">edit</span>
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            className="ctcBtn ctcBtnDelete"
                                            title="Supprimer"
                                            onClick={() => delContact(e)}
                                        >
                                            <span className="material-symbols-outlined">delete</span>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TableContactCustomer;
